<template>
	<span style="z-index: 1" :class="stockClass" :title="stockText" />
</template>

<script>
import { inStockAnywhere, isProductReleased, releaseToString, shouldShowStock } from 'utils';
import {mapState} from "vuex";

export default {
	props: {
		stock: {
			type: [Object, Array], // @TODO eller.. array?
			default: () => {},
		},
		release: {
			type: Object,
		},
		store: {
			type: String,
			default: null,
		},
		product: {
			type: Object,
			required: true,
		},
	},
	computed: {
		...mapState({
			user: state => state.user,
		}),
		isReleased () {
			if (! this.release) {
				return true;
			}

			return isProductReleased(this.release);
		},
		releaseDate () {
			if (! this.release) {
				return '';
			}

			return releaseToString(this.release);
		},
		stockClass () {
			if (! this.isReleased || ! shouldShowStock(this.product, this.user)) {
				return 'stock-icon-notreleased';
			} else if (this.inStock) {
				return 'stock-icon-instock';
			} else {
				return 'stock-icon-outofstock';
			}
		},
		stockText () { // @TODO translate
			if (! shouldShowStock(this.product, this.user)) {
				return 'Ej i lager';
			} else if (! this.isReleased) {
				return this.releaseDate;
			} else if (this.inStock) {
				return 'I lager';
			} else {
				return 'Ej i lager';
			}
		},
		inStock () {
			return this.store ? this.stock[this.store] : inStockAnywhere(this.stock);
		},
	},
};
</script>
